import axios from "axios";
import { baseUrl } from "../constants/urls";
import { useEffect } from "react";

export const getApi = (url) => {
    return axios.get(baseUrl + url);
}

export const postApi = (url, payload, headers) => {
    return axios.post(baseUrl + url, payload, {headers});
}

export const getLocalJsonApi = (url) => {
    return axios.get(url);
}
